import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	hierarchy: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.hierarchy',
		defaultMessage: 'Hierarchy',
		description: 'The label for the hierarchy information in the export view',
	},
	hierarchySeparator: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.hierarchy-separator',
		defaultMessage: 'to',
		description: 'The separator between hierarchy range. E.g. Epic "to" Subtask',
	},
	view: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.view',
		defaultMessage: 'View',
		description: 'The label for the view settings information in the export view',
	},
	colorBy: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.color-by',
		defaultMessage: 'Color by',
		description: 'The label for the colouring information in the export view',
	},
	rollup: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.rollup',
		defaultMessage: 'Roll-up',
		description: 'The label for the rollup settings information in the export view',
	},
	rollupAll: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.rollup-all',
		defaultMessage: 'Yes',
		description: 'The label for when all rollup settings are activated',
	},

	rollupOthers: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.rollup-others',
		defaultMessage: 'Not dates',
		description: 'The label for when rollup others is enabled but not dates',
	},
	sortBy: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.sort-by',
		defaultMessage: 'Sort by',
		description: 'The label for the sorting information in the export view',
	},
	rank: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.rank',
		defaultMessage: 'Rank',
		description: 'The descriptor shown when sorting is applied by lexorank',
	},
	filters: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.filters',
		defaultMessage: `{filtersApplied, plural,
            =0 {Filters}
            one {1 filter applied}
            other {{filtersApplied} filters applied}
        }`,
		description: 'The label for the filters information in the export view',
	},
	noFilterApplied: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.no-filter-applied',
		defaultMessage: 'No filter applied',
		description: 'The label to indicate no filter is applied in the export view',
	},
	warnings: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.warnings',
		defaultMessage: 'Warnings',
		description: 'The label for the warning information in the export view',
	},
	warningsEnabled: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.warnings-enabled',
		defaultMessage: 'Enabled',
		description: 'The label to indicate whether the "show warnings" setting is enabled',
	},
	warningsDisabled: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.warnings-disabled',
		defaultMessage: 'Disabled',
		description: 'The label to indicate whether the "show warnings" setting is disabled',
	},
	showFullHierarchy: {
		id: 'portfolio-3-portfolio.app-export-view.main.view-information.show-full-hierarchy',
		defaultMessage: 'Showing full hierarchy',
		description: 'The label to indicate whether the "Show full hierarchy" setting is enabled',
	},
});
